// src/utils/checkGuess.ts
export function checkGuess(
  target: string[],
  guess: string[]
): ('G' | 'R')[] {
  return guess.map((letter, i) => (letter === target[i] ? 'G' : 'R'));
}
